module.exports = __webpack_public_path__ + "img/wxvideo.ffd409ca.svg";